@if (type === 'overlay') {
  <div class="toolbox-overlay"
       [style.visibility]="componentVisible ? 'visible' : 'hidden'" >
    <div [ngClass]='["background", type]'></div>
    <mat-card [ngClass]='["toolbox", type, displayTitle ? "w-title" : "wo-title"]'>
      <mat-card-header>
        @if (displayTitle) {
          <mat-card-title>
            {{ 'i18n.toolbox.preview.title' | translate }}
          </mat-card-title>
        }
        <mat-icon svgIcon="close"
          class="close-x"
        (click)="btnCancelClick()"></mat-icon>
      </mat-card-header>
      <mat-card-content>
        <preview [stageID]="stageID"
          [previewType]="previewType">
        </preview>
      </mat-card-content>
    </mat-card>
  </div>
}

@if (type === 'static') {
  <div class="toolbox-static"
       [style.visibility]="componentVisible ? 'visible' : 'hidden'" >
    <div class="header">
      @if (displayTitle) {
        @if (displayTitle) {
          <span class="title">
            <mat-icon svgIcon="preview"></mat-icon>
            {{ 'i18n.toolbox.preview.title' | translate }}
          </span>
        }
        <hr class="title-hr" />
      }
    </div>
    <div class="body">
      <preview [stageID]="stageID"
        [previewType]="previewType">
      </preview>
    </div>
  </div>
}
